import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from './core/services/auth.service';
import { CommonHttpService } from './core/services/common-http.service';
import { LoginService } from './core/services/login.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'risk-assessment';
  isLoggedIn!: boolean;
  isLoading$!: Observable<boolean>;
  isLoading: boolean = false;

  constructor(private authService: AuthService, private loginService: LoginService,
    private _commonHttpService: CommonHttpService, private changeDetectorRef: ChangeDetectorRef,private router: Router) {
    this.isLoggedIn = this.authService.isLoggedInUser();
  }
  ngOnInit(): void {
    this.isLoading$ = this._commonHttpService.getLoading();
    this.isLoading$.subscribe((state: any) => {
      this.isLoading = state;
      this.changeDetectorRef.detectChanges();
    })
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');

    if (code && state) {
      // First navigate with query params
      this.router.navigate(['/login'], {
        queryParams: { code, state },
        queryParamsHandling: 'merge' // optional
      }).then(() => {
        // After navigation, clean up URL so params are not visible
        window.history.replaceState({}, document.title, window.location.origin + '/#/login');
      });
    }
  }

  @HostListener('mouseenter', ['$event'])
  onMouseEnter(event: any) {
    if (this.authService.isLoggedInUser()) {
      this.loginService.clearPortalInactiveTimeout();
    }
  }
  @HostListener('mousemove', ['$event'])
  onMousemove(event: any) {
    if (this.authService.isLoggedInUser()) {
      this.loginService.clearPortalInactiveTimeout();
    }
  }
  @HostListener('window:click', ['$event'])
  onClick(event: any) {
    if (this.authService.isLoggedInUser()) {
      this.loginService.clearPortalInactiveTimeout();
    }
  }
  @HostListener('window:keydown', ['$event'])
  onKeydown(event: any) {
    if (this.authService.isLoggedInUser()) {
      this.loginService.clearPortalInactiveTimeout();
    }
  }
  @HostListener('window:scroll', ['$event'])
  onScroll(event: any) {
    if (this.authService.isLoggedInUser()) {
      this.loginService.clearPortalInactiveTimeout();
    }
  }
}
